import React from 'react';
import ReactEcharts from 'echarts-for-react';
import { connect } from 'react-redux';
import { Spin, Card } from 'antd';
import { Row, Col } from 'antd';
class AgentChart extends React.Component {
    getOption1 = data => {
        const dateList = data.map(function(item) {
            return item.time;
        });
        const reqList = data.map(function(item) {
            return item.clickErrorR;
        });
        const option = {
            legend: {
                data: ['点击失败率'],
            },
            title: [
                {
                    text: '点击出错比率',
                    subtext: '比率',
                },
            ],
            tooltip: {
                trigger: 'axis',
            },
            xAxis: [
                {
                    type: 'category',
                    // boundaryGap: false,
                    data: dateList,
                },
            ],
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: '{value}',
                },
            },
            series: [
                {
                    name: '点击失败率',
                    type: 'bar',
                    // smooth: false,
                    // symbol: 'none',
                    // sampling: 'average',
                    itemStyle: {
                        normal: {
                            color: function(params) {
                                // build a color map as your need.
                                let colorList = [
                                    '#C1232B', '#B5C334', '#FCCE10', '#E87C25', '#27727B',
                                    '#FE8463', '#9BCA63', '#FAD860', '#F3A43B', '#60C0DD',
                                    '#D7504B', '#C6E579', '#F4E001', '#F0805A', '#26C0C0',
                                ];
                                return colorList[params.dataIndex];
                            },
                            label: {
                                show: true,
                                position: 'top',
                                formatter: '{b}\n{c}'
                            },
                        },
                    },
                    // markPoint: {
                    //     data: [
                    //         {type: 'max', name: '最大值'},
                    //         {type: 'min', name: '最小值'},
                    //         {coord: ['云立方'], name: '出错率'}
                    //     ],
                    // },
                    markLine: {
                        data: [
                            {
                                label: {normal: {formatter: '{c}%'}},
                                lineStyle: {normal: {color: '#20A0FF'}},
                                yAxis: 10,
                                name: '基准线',
                            },
                        ],
                    },
                    data: reqList,
                    // lineStyle: {
                    //     normal: {
                    //         color: '#1890ff', // 连线颜色
                    //     },
                    // },
                },
            ],
        };

        return option;
    };
    getOption2(data) {
        const dateList = data.map(function(item) {
            return item.time;
        });
        const reqList = data.map(function(item) {
            return item.evErrorR;
        });
        const option = {
            legend: {
                data: ['曝光失败比率'],
            },
            title: [
                {
                    text: '曝光出错比率',
                    subtext: '比率',
                },
            ],
            tooltip: {
                trigger: 'axis',
            },
            xAxis: [
                {
                    type: 'category',
                    // boundaryGap: false,
                    data: dateList,
                },
            ],
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: '{value}',
                },
            },
            series: [
                {
                    name: '曝光失败比率',
                    type: 'bar',
                    // smooth: false,
                    // symbol: 'none',
                    // sampling: 'average',
                    itemStyle: {
                        normal: {
                            color: function(params) {
                                // build a color map as your need.
                                let colorList = [
                                    '#C1232B', '#B5C334', '#FCCE10', '#E87C25', '#27727B',
                                    '#FE8463', '#9BCA63', '#FAD860', '#F3A43B', '#60C0DD',
                                    '#D7504B', '#C6E579', '#F4E001', '#F0805A', '#26C0C0',
                                ];
                                return colorList[params.dataIndex];
                            },
                            label: {
                                show: true,
                                position: 'top',
                                formatter: '{b}\n{c}'
                            },
                        },
                        symbolSize: 20,
                    },
                    markLine: {
                        data: [
                            {
                                label: {normal: {formatter: '{c}%'}},
                                lineStyle: {normal: {color: '#20A0FF'}},
                                yAxis: 10,
                                name: '基准线',
                            },
                        ],
                    },
                    data: reqList,
                    // lineStyle: {
                    //     normal: {
                    //         color: '#1890ff', // 连线颜色
                    //     },
                    // },
                },
            ],
        };

        return option;
    }
    getOption3(data) {
        let dateList = [];
        let legendData = [];
        let seriesData = [];
        console.log("getOption3",data);
        if (data.length) {
            dateList = data[0].detail.map(item => {
                return item.time;
            });
            legendData = data.map(item => item.time);
            seriesData = data.map(item => {
                let {detail} = item;
                let ip = detail.map(d => d.ipDistinctCount);
                return {
                    name: item.time,
                    type: 'line',
                    smooth: false,
                    symbol: 'none',
                    sampling: 'average',
                    markLine: {},
                    data: ip,
                };
            });
        }
        // console.log('options=======', legendData, seriesData)
        const option = {
            legend: {
                data: legendData,
            },
            title: [
                {
                    text: '新增IP数',
                    subtext: '新增IP数',
                },
            ],
            tooltip: {
                trigger: 'axis',
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: false,
                    data: dateList,
                },
            ],
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: '{value}',
                },
            },
            // dataZoom: [
            //     {
            //         type: 'inside',
            //         start: 0,
            //         end: 100,
            //     },
            //     {
            //         start: 0,
            //         end: 10,
            //         handleIcon:
            //             'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            //         handleSize: '80%',
            //         handleStyle: {
            //             color: '#fff',
            //             shadowBlur: 3,
            //             shadowColor: 'rgba(0, 0, 0, 0.6)',
            //             shadowOffsetX: 2,
            //             shadowOffsetY: 2,
            //         },
            //     },
            // ],
            series: seriesData,
        };

        return option;
    }

    render() {
        const { isShowEchart, charts } = this.props;
        return (
            <Spin spinning={isShowEchart} tip="加载中...">
                <Row>
                    <Col span={8}>
                        <div style={{ height: '300px', width: '86%'}}>
                            <ReactEcharts ref="echarts_react" option={this.getOption3.bind(this)(charts)} notMerge={true}/>
                        </div>
                    </Col>
                    <Col span={8}>
                        <div style={{ height: '300px', width: '86%'}}>
                            <ReactEcharts ref="echarts_react" option={this.getOption1.bind(this)(charts)} />
                        </div>
                    </Col>
                    <Col span={8}>
                        <div style={{ height: '300px', width: '86%'}}>
                            <ReactEcharts ref="echarts_react" option={this.getOption2.bind(this)(charts)} />
                        </div>
                    </Col>
                </Row>
            </Spin>
        );
    }
}

const mapStateToProps = state => ({
    charts: state.agencyAnalysis.agentsGroup,
    isShowEchart: state.agencyAnalysis.uiStatus.isAgentLoading,
});

export default connect(mapStateToProps, null)(AgentChart);



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/agencyAnalysis/agentCharts.js